import api from '@/api';

const resource = 'ei/distribuirnotas';

export default {
  getMaxAnoLetivo(data){
    return api.get(`${resource}/anoletivo`,{
      params: data,
    })
  },
  getEtapa(data){
    return api.get(`${resource}/etapaescolar`,{
      params: data,
    })
  },
  getEtapaGrade(data){
    return api.get(`${resource}/etapagrade`,{
      params: data,
    })
  },
  getDistribuicao(data){
    return api.get(`${resource}`,{
      params: data,
    })
  },
  getMatriz(data){
    return api.get(`${resource}/matriz`,{
      params: data,
    })
  },
  postDistribuicao(data) {
    return api.post(`${resource}`, data);
  },
};